import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import Styled from "styled-components";
import Button from "@material-ui/core/Button";
import DoubleArrowIcon from "@material-ui/icons/DoubleArrow";
import SaveIcon from "@material-ui/icons/Save";
import Typography from "@material-ui/core/Typography";
import { Add, Remove } from "@material-ui/icons";
import { DatePicker } from "@material-ui/pickers";
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";

import { useAuth } from "../../context/GlobalContext";
import formatDate from "../../components/Control/formatDate";
import { Wrapper } from "../../components/Control/Flexbox";
import { CenteredLogoImg } from "../../golbalStyles/global.styled";
import { images, textInputs } from "../../constants/constants";
import ForMTable from "../DailyProduction/ForMTable";
import Modal from "../../components/Control/Modal";
import useConfirm from "../../components/Control/useConfirm";
import { CloseButton } from "../../GlobalUtils/ButtonsGlobal";
import SelectPart from "../DailyProduction/SelectPart";
import { Autocomplete } from "@material-ui/lab";
import TableInput from "../../components/Control/TableInput";
import { calcRej } from "./calculateRejection";
import RejectionTable from "./RejectionTable";

const Table = Styled.table`
	margin-bottom: 1rem;
  width: 100%;
    th{
        font-size: 12px;
		    font-family:"Roboto",sans-serif;
        border: 1px solid black;
        padding: 0.4rem;
        p{
          margin:0;
        }
    }
    td{
        font-size: 12px;
        border: 1px solid black;
        padding: 0.3rem;
        p{
          margin:0;
        }
    }
    span{
      font-weight:500;
    }

`;

const dropdownStyles = makeStyles({
  root: {
    backgroundColor: "#fff",
  },
  select: {
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&:focus": {
      backgroundColor: "#fff",
    },
  },
  underline: {
    borderBottom: "0px solid red !important",
    "&:hover": {
      borderBottom: "0px solid rgba(0,0,0,0)",
    },
  },
});

const getTotalProductionPlan = (data) => {
  return data.processes.reduce(
    (acc, curr) => acc + (+curr.production_plan || 0),
    0,
  );
};
const getTotalAcctualPlan = (data) => {
  return data.processes.reduce((acc, curr) => acc + (+curr.actual_qty || 0), 0);
};
const ProductionPlanningTable = () => {
  const classes = dropdownStyles();
  const index4m = useRef(0);
  const tabValue4m = useRef(0);
  const history = useHistory();
  const { id } = useParams();
  const { state } = useAuth();
  const [is4mModal, setIs4mModal] = useState(false);
  const [isOpenPopupForRejections, setIsOpenPopupRejections] = useState(false);
  const [rejectionsIndx, setRejectionsIndx] = useState(0);
  const documentTypeRef = useRef(null);
  const [render, setRender] = useState(false);
  const [isdisableClose, setDisableClose] = useState(false);
  const [partDetails, setPartDetails] = useState();
  const [productionPlanningData, setProductionPlanningData] = useState({
    processes: new Array(50).fill().map((_, index) => ({
      sr_no: index + 1,
      reason_of_rejection: Array.from({ length: 10 }, (_, index) => ({
        reason: "",
        rej_qty: null,
      })),
    })),
  });
  console.log(productionPlanningData);
  const [isSelectPartModal, selectSelectPartModal] = useState(false);
  const indexSelectPart = useRef(0);

  const [DialogClose, confirmClose] = useConfirm(
    "CLOSE",
    "Are you sure you want to leave this page?",
  );
  const [DialogSave, confirmSave] = useConfirm(
    "SAVE",
    "Are you sure you want to save document",
  );
  const [DialogUpdate, confirmUpdate] = useConfirm(
    "UPDATE",
    "Are you sure you want to update document",
  );
  const [departments, setDepartments] = useState([]);
  useEffect(() => {
    axios
      .get("/api/getAllDepartment")
      .then((res) => {
        if (res.data) {
          setDepartments(res.data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    axios
      .get(`/api/getPartDetails`)
      .then((res) => {
        setPartDetails(res.data.results);
      })
      .catch((err) => console.log(err));
  }, []);
  useEffect(() => {
    if (!id) return;
    axios
      .get(`/api/getOneProductionPlanning/${id}`)
      .then((res) => {
        setProductionPlanningData(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  const handleChangeProduction = (e, index) => {
    const value = e.target.innerText;
    const name = e.target.dataset.name;
    productionPlanningData.processes[index][name] = value;
  };

  const handle4m = (value, documentType) => {
    if (documentType === "machine") {
      productionPlanningData.processes[index4m.current].machine_no = value;
    }
    if (documentType === "operator") {
      productionPlanningData.processes[index4m.current].operator_name = value;
    }
    setRender((prev) => !prev);
  };
  const reset4m = (documentType) => {
    if (documentType === "machine") {
      productionPlanningData.processes[index4m.current].machine_no = null;
    }
    if (documentType === "operator") {
      productionPlanningData.processes[index4m.current].operator_name = null;
    }
    setRender((prev) => !prev);
  };

  const handleSubmitAndSave = async (bool) => {
    if (id) {
      const isConfirm = await confirmUpdate();
      if (isConfirm) {
        productionPlanningData.isSubmitted = bool;
        productionPlanningData.report_prepared_by = state.user?.name;
        axios
          .put(`/api/updateProductionPlanning/${id}`, productionPlanningData)
          .then((res) => {
            if (res.data.status === "success") {
              history.push("/productionPlanningcontrol/create");
            }
          })
          .catch((err) => console.log(err));
      }
    } else {
      const isConfirm = await confirmSave();

      if (isConfirm) {
        productionPlanningData.isSubmitted = bool;
        productionPlanningData.is_admin_request = "pending";
        productionPlanningData.report_prepared_by = state.user?.name;
        axios
          .post(`/api/productionPlanning/create`, productionPlanningData)
          .then((res) => {
            if (res.data.status === "success") {
              history.push("/productionPlanningcontrol/create");
            }
          })
          .catch((err) => console.log(err));
      }
    }
  };

  const handlePartDetails = (partId, value) => {
    productionPlanningData.processes[indexSelectPart.current].part_id = partId;
    productionPlanningData.processes[indexSelectPart.current].part_number =
      value;
    setRender((prev) => !prev);
  };

  const resetPartDetails = () => {
    productionPlanningData.processes[indexSelectPart.current].part_id = null;
    productionPlanningData.processes[indexSelectPart.current].part_number =
      null;
    productionPlanningData.processes[indexSelectPart.current].part_name = null;
    setRender((prev) => !prev);
  };

  return (
    <section>
      <div style={{ paddingBottom: "4rem" }}>
        <div className="divflex">
          <Typography
            style={{
              fontSize: "24px",
              fontFamily: "Nunito",
              textTransform: "uppercase",
            }}
          >
            Production Planning & Control Report
          </Typography>
          <div style={{ display: "flex" }}>
            <Wrapper
              style={{
                gap: "1rem",
              }}
            >
              <Button
                type="button"
                variant="contained"
                color="primary"
                size="large"
                style={{
                  backgroundColor: "#003566",
                  marginRight: "0.5rem",
                }}
                onClick={() => {
                  handleSubmitAndSave(false);
                }}
                startIcon={<SaveIcon />}
              >
                Save & Continue
              </Button>
              <Button
                type="button"
                variant="contained"
                color="primary"
                size="large"
                style={{
                  backgroundColor: "#064a29",
                  marginRight: "0.5rem",
                }}
                startIcon={<CloudUploadIcon />}
                onClick={() => {
                  handleSubmitAndSave(true);
                }}
              >
                Submit
              </Button>
              <CloseButton
                onClick={async () => {
                  let ans = await confirmClose();
                  if (ans) {
                    history.goBack();
                  }
                }}
              />
            </Wrapper>
          </div>
        </div>

        <div
          style={{
            margin: "0.1rem 0.5rem",
            paddingBottom: "4rem",
            overflowX: "scroll",
          }}
        >
          <Table
            cellSpacing="0"
            style={{ marginTop: "0.6rem", backgroundColor: "white" }}
            id="table-to-xls"
          >
            <thead>
              <tr data-height="80" style={{ height: "70px" }}>
                <th
                  colSpan="11"
                  align="left"
                  style={{
                    border: "1px solid black",
                    fontSize: "1.6rem",
                    textAlign: "center",
                  }}
                  data-a-v="middle"
                >
                  <CenteredLogoImg>
                    <img
                      src={images.arcLogo}
                      alt={textInputs.companyName}
                      height="46"
                      width="120"
                    />
                    <span>{textInputs.companyName}</span>
                  </CenteredLogoImg>
                </th>
                <th
                  style={{
                    border: "1px solid black",
                  }}
                >
                  DOC NO:ARC/F/PPC/01
                </th>
              </tr>

              <tr>
                <th
                  colSpan="11"
                  align="center"
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: 600,
                    backgroundColor: "#1d1d1d",
                    color: "white",
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                  data-font-sz="18"
                  data-a-h="center"
                  data-f-bold="true"
                  data-fill-color="#1d1d1d"
                  data-f-color="FFFFFF"
                >
                  Daily Production Plan v/s Actual
                </th>
                <th style={{ border: "1px solid black" }} data-f-sz="10">
                  REV.NO/DATE-02/07/2019{" "}
                </th>
              </tr>
              <tr>
                <th colSpan={8} style={{ border: "1px solid black" }}>
                  <Wrapper style={{ gap: "5px" }}>
                    Date:-
                    <DatePicker
                      // label="pic Date"
                      name="date_performance"
                      format="dd/MM/yyyy"
                      InputProps={{
                        disableUnderline: true,
                      }}
                      style={{
                        backgroundColor: "#f8f9fa",
                      }}
                      value={productionPlanningData.productionPlanning_date}
                      onChange={(date) => {
                        productionPlanningData.productionPlanning_date = date;
                        setRender((prev) => !prev);
                      }}
                    />
                  </Wrapper>
                </th>
                <th style={{ border: "1px solid black" }}>Shift:</th>
                <th
                  colSpan={3}
                  align="center"
                  contenteditable="true"
                  data-name="shift"
                  onKeyUp={(e) => {
                    productionPlanningData[e.target.dataset.name] =
                      e.target.innerText;
                  }}
                  style={{
                    border: "1px solid black",
                    backgroundColor: "#f9e0e0",
                  }}
                >
                  {productionPlanningData.shift}
                </th>
              </tr>
              <tr>
                <th>Department:</th>
                <th colSpan={11}>
                  <Autocomplete
                    id="department_id"
                    options={departments}
                    getOptionLabel={((option) => option.department_name) || []}
                    value={productionPlanningData.department_id || ""}
                    style={{
                      border: "1px solid #ced4da",
                      minWidth: "230px",
                      height: "45px",
                    }}
                    onChange={(e, value) => {
                      productionPlanningData.department_id = value;
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          disableUnderline: true,
                        }}
                        // style={{ border: "1px solid #ced4da" }}
                      />
                    )}
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                {[
                  "Sr. No",
                  "Machine No.",
                  "Sch Qty",
                  "Lot Qty",
                  "Part No.",
                  "Production Plan",
                  "Actual Qty",
                  "Failure Qty",
                  "Reason for Failures",
                  "Production %",
                  "Heat No.",
                  "Remarks",
                ].map((heading, index) => (
                  <th
                    key={index}
                    style={{
                      border: "1px solid black",
                      textAlign: "center",
                      textTransform: "uppercase",
                    }}
                  >
                    {heading}
                  </th>
                ))}
              </tr>
              {productionPlanningData.processes.map((item, index) => (
                <tr key={item._id || index}>
                  <td>{item.sr_no}</td>
                  <th
                    style={{
                      width: "100px",
                      border: "1px solid black",
                      textAlign: "center",
                      padding: "0 0.4rem",
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    <Wrapper
                      justify="space-between"
                      style={{ width: "200px", backgroundColor: "#f8f9fa" }}
                    >
                      <p
                        style={{
                          fontSize: "0.8rem",
                        }}
                      >
                        {item.machine_no || "Pick Machine"}
                      </p>
                      {item.machine_no ? (
                        <Wrapper
                          className="pir_add_modal"
                          style={{ backgroundColor: "#003566" }}
                          justify="center"
                          onClick={() => {
                            item.machine_no = null;
                            setRender((prev) => !prev);
                          }}
                        >
                          <Remove />
                        </Wrapper>
                      ) : (
                        <Wrapper
                          className="pir_add_modal"
                          justify="center"
                          style={{ backgroundColor: "#495057" }}
                          onClick={() => {
                            index4m.current = index;
                            documentTypeRef.current = "machine";
                            setIs4mModal(true);
                          }}
                        >
                          <Add />
                        </Wrapper>
                      )}
                    </Wrapper>
                  </th>
                  <td
                    align="center"
                    contenteditable="true"
                    data-name="sch_qty"
                    onKeyUp={(e) => {
                      handleChangeProduction(e, index);
                    }}
                    style={{
                      border: "1px solid black",
                      backgroundColor: "#f9e0e0",
                    }}
                  >
                    {item.sch_qty}
                  </td>
                  <td
                    align="center"
                    contenteditable="true"
                    data-name="lot_qty"
                    onKeyUp={(e) => {
                      handleChangeProduction(e, index);
                    }}
                    style={{
                      border: "1px solid black",
                      backgroundColor: "#f9e0e0",
                    }}
                  >
                    {item.lot_qty}
                  </td>
                  {/* <th
                    style={{
                      width: "100px",
                      border: "1px solid black",
                      textAlign: "center",
                    }}
                  >
                    <FormControl
                      style={{
                        width: "250px",
                        border: "none",
                      }}
                      fullWidth={true}
                      variant="filled"
                      classes={{
                        root: classes.root,
                      }}
                    >
                      <InputLabel>Select Part No</InputLabel>
                      <Select
                        defaultValue={item.part_no || ""}
                        classes={{
                          // underline: classes.underline,
                          root: classes.root,
                          select: classes.select,
                        }}
                        disableUnderline
                        onChange={(e) =>
                          (productionPlanningData.processes[index].part_no =
                            e.target.value)
                        }
                      >
                        {partDetails &&
                          partDetails.map((data, PIndex) => (
                            <MenuItem
                              className="option"
                              key={PIndex}
                              value={data.part_number}
                            >
                              {data.part_number}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </th> */}
                  <th
                    style={{
                      width: "100px",
                      border: "1px solid black",
                      textAlign: "center",
                      padding: "0 0.4rem",
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    <Wrapper
                      justify="space-between"
                      style={{ width: "200px", backgroundColor: "#f8f9fa" }}
                    >
                      <p
                        style={{
                          fontSize: "0.8rem",
                        }}
                      >
                        {item?.part_id?.part_number ||
                          item?.part_number ||
                          "Pick Part No."}
                      </p>
                      {item?.part_number || item?.part_id?.part_number ? (
                        <Wrapper
                          className="pir_add_modal"
                          style={{ backgroundColor: "#003566" }}
                          justify="center"
                          onClick={() => {
                            item.part_number = null;
                            item.part_id = null;

                            setRender((prev) => !prev);
                          }}
                        >
                          <Remove />
                        </Wrapper>
                      ) : (
                        <Wrapper
                          className="pir_add_modal"
                          justify="center"
                          style={{ backgroundColor: "#495057" }}
                          onClick={() => {
                            indexSelectPart.current = index;
                            selectSelectPartModal(true);
                          }}
                        >
                          <Add />
                        </Wrapper>
                      )}
                    </Wrapper>
                  </th>
                  <td>
                    <TableInput
                      isView={false}
                      name="production_plan"
                      type="number"
                      value={item.production_plan}
                      onChange={(e) => {
                        item.production_plan = e.target.value;
                        item.rejection_qty = calcRej(
                          item.production_plan,
                          item.actual_qty,
                        );
                        setRender((prev) => !prev);
                      }}
                    />
                  </td>
                  <td>
                    <TableInput
                      isView={false}
                      name="actual_qty"
                      type="number"
                      value={item.actual_qty}
                      onChange={(e) => {
                        item.actual_qty = e.target.value;
                        item.rejection_qty = calcRej(
                          item.production_plan,
                          item.actual_qty,
                        );
                        setRender((prev) => !prev);
                      }}
                    />
                  </td>
                  <td>{item.rejection_qty}</td>
                  <td
                    style={{
                      width: "300px",
                      minWidth: "300px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ border: "none" }}>
                        {item?.reason_of_rejection?.map((d) => {
                          console.log(d);
                          return d?.reason ? (
                            <span>
                              {d?.reason} - {d?.rej_qty}
                              <br />
                              <hr />
                            </span>
                          ) : null;
                        })}
                      </div>
                      {item.rejection_qty && (
                        <Wrapper
                          className="pir_add_modal"
                          style={{ backgroundColor: "#003566" }}
                          justify="center"
                          onClick={() => {
                            if (!item?.reason_of_rejection) {
                              item.reason_of_rejection = Array.from(
                                ({ length: 10 },
                                (_idx) => ({
                                  reason: "",
                                  rej_qty: null,
                                })),
                              );
                            }
                            setIsOpenPopupRejections(true);
                            setRejectionsIndx(index);
                          }}
                        >
                          <Add />
                        </Wrapper>
                      )}
                    </div>
                  </td>
                  <td align="center">
                    {isNaN(+item.actual_qty / +item.production_plan)
                      ? ""
                      : (
                          (+item.actual_qty / +item.production_plan) *
                          100
                        ).toFixed(2)}
                  </td>
                  <td
                    align="center"
                    contenteditable="true"
                    data-name="heat_no"
                    onKeyUp={(e) => {
                      handleChangeProduction(e, index);
                    }}
                    style={{
                      border: "1px solid black",
                      backgroundColor: "#f9e0e0",
                    }}
                  >
                    {item.heat_no}
                  </td>
                  <td
                    align="center"
                    contenteditable="true"
                    data-name="remark"
                    onKeyUp={(e) => {
                      handleChangeProduction(e, index);
                    }}
                    style={{
                      border: "1px solid black",
                      backgroundColor: "#f9e0e0",
                    }}
                  >
                    {item.remark}
                  </td>
                </tr>
              ))}
              <tr>
                <th colSpan={5}>TOTAL:</th>
                <th>{getTotalProductionPlan(productionPlanningData)}</th>
                <th>{getTotalAcctualPlan(productionPlanningData)}</th>
                <th>
                  {getTotalProductionPlan(productionPlanningData) -
                    getTotalAcctualPlan(productionPlanningData)}
                </th>
                <th></th>
                <th>
                  {isNaN(
                    getTotalAcctualPlan(productionPlanningData) /
                      getTotalProductionPlan(productionPlanningData),
                  )
                    ? ""
                    : (
                        (getTotalAcctualPlan(productionPlanningData) /
                          getTotalProductionPlan(productionPlanningData)) *
                        100
                      ).toFixed(2)}
                  {}
                </th>
                <th></th>
                <th></th>
              </tr>
            </tbody>
            <tfoot>
              <tr style={{ height: "60px" }} data-height="35">
                <td
                  align="left"
                  colSpan={2}
                  style={{ fontWeight: 500, border: "1px solid black" }}
                >
                  Prepared By:
                </td>
                <td
                  align="left"
                  colSpan={4}
                  style={{
                    border: "1px solid black",
                    textTransform: "capitalize",
                  }}
                >
                  {productionPlanningData?.report_prepared_by}
                </td>

                <td
                  align="left"
                  colSpan={2}
                  style={{ fontWeight: 500, border: "1px solid black" }}
                >
                  Approved By:
                </td>
                <td
                  align="left"
                  style={{
                    border: "1px solid black",
                    textTransform: "capitalize",
                  }}
                  colSpan={4}
                >
                  {productionPlanningData?.is_admin_request === "accepted" &&
                    productionPlanningData?.report_approved_by}
                </td>
              </tr>
            </tfoot>
          </Table>
        </div>
      </div>
      <Modal
        openPopup={is4mModal}
        title="MACHINE LIST"
        closeModal={(e) => setIs4mModal(false)}
      >
        <ForMTable
          {...{ handle4m, reset4m }}
          processes={productionPlanningData.processes[index4m.current]}
          departmentId={productionPlanningData.department_id?._id}
          index4m={index4m.current}
          // tabValue4m={tabValue4m.current}
          documentType={documentTypeRef.current}
          dontShowMan={true}
        />
      </Modal>
      <Modal
        openPopup={isSelectPartModal}
        title="Select PART"
        closeModal={(e) => selectSelectPartModal(false)}
      >
        <SelectPart
          {...{ handlePartDetails, resetPartDetails }}
          processes={productionPlanningData.processes[indexSelectPart.current]}
        />
      </Modal>
      <Modal
        title="Failures List"
        isModalCloseBtn={isdisableClose}
        openPopup={isOpenPopupForRejections}
        closeModal={() => {
          setIsOpenPopupRejections(false);
        }}
      >
        <RejectionTable
          process={productionPlanningData.processes[rejectionsIndx]}
          isView={false}
          setDisableClose={setDisableClose}
        />
      </Modal>
      <DialogSave isSubmitContent={true} />
      <DialogClose isSubmitContent={false} />
      <DialogUpdate isSubmitContent={false} />
    </section>
  );
};

export default ProductionPlanningTable;
